import { computed, defineComponent, type PropType, ref, Transition, unref } from 'vue'
import type { IConfig } from '-/Base/BdTable'
import { Dropdown, Menu, message } from 'ant-design-vue'
import styles from './index.module.less'
export default defineComponent({
  name: 'MutipleSelectBox',
  props: {
    keys: {
      type: Object as PropType<(string | number)[]>,
      default: null
    },
    actions: {
      type: Array as PropType<IConfig['mutipleAction']>,
      default: () => []
    },
    dataSource: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    reloadFn: {
      type: Function as PropType<BD.Fn>,
      required: true
    }
  },
  emits: ['update:keys', 'update:dataSource'],
  setup(props, ctx) {
    const isVisible = computed(() => !!props.keys?.length)
    const loading = ref(false)
    const clear = () => {
      ctx.emit('update:keys', [])
      ctx.emit('update:dataSource', [])
    }
    const reload = async () => {
      await props.reloadFn()
    }
    const renderMenu = () => (
      <Menu>
        {props.actions?.map(item => (
          <div v-permission={item.permission} class={styles.item}>
            <Menu.Item
              onClick={async () => {
                if (item.customFn) {
                  item.customFn(props.keys, props.dataSource, clear, reload)
                  return
                }
                const _params = item.before?.(props.keys, props.dataSource) ?? { ids: props.keys }
                loading.value = true
                try {
                  await item.fn?.(_params)
                  if (item.disableReload) {
                    clear()
                  } else {
                    await reload()
                    message.success(`${item.title}成功`)
                  }
                } catch (err) {
                  message.error(`${item.title}失败`)
                }
                loading.value = false
              }}
              class={item.danger ? styles.danger : ''}
            >
              {item.title}
            </Menu.Item>
          </div>
        ))}
      </Menu>
    )
    return () => (
      <Transition name='scale' mode='out-in'>
        {unref(isVisible) ? (
          <Dropdown.Button loading={unref(loading)} overlay={renderMenu()}>
            批量操作({props.keys?.length})
          </Dropdown.Button>
        ) : null}
      </Transition>
    )
  }
})
